export default __webpack_public_path__ + "static/media/kstud.30f190cd.png";